import styled from 'styled-components'

import { themeColor } from '../theme'

export const ClickableTableCell = styled.div`
  font-weight: bold;
  color: ${themeColor('primary')};
  cursor: pointer;

  /* Safari fix, prevent clickable area to have zero width/height if wrongly computed from child <img> */
  min-width: 24px;
  min-height: 24px;
`
